// Simplified (business-oriented) transaction types — a UI/derivation layer.
// Each type maps to a transaction direction and the candidate Project Account
// types it can target. Keep in sync with the backend
// api/queries/transaction_types.py.

// `direction: null` marks a custom type where the user picks the direction and any
// project account themselves. `requiresSupplier` controls whether the supplier
// selector is shown (supplier is nullable now; non-supplier flows record null).
export const TRANSACTION_TYPES = [
    { id: 'pay_supplier', direction: 'expense', accountTypes: ['expenses'], requiresSupplier: true },
    { id: 'receive_supplier_refund', direction: 'income', accountTypes: ['expenses'], requiresSupplier: true },
    { id: 'record_customer_funds_deposit', direction: 'income', accountTypes: ['funds'], requiresSupplier: false },
    { id: 'receive_customer_payment', direction: 'income', accountTypes: ['revenue'], requiresSupplier: false },
    { id: 'receive_owner_contribution', direction: 'income', accountTypes: ['investment'], requiresSupplier: false },
    { id: 'custom', direction: null, accountTypes: [], requiresSupplier: false, custom: true },
];

export const TRANSACTION_TYPES_BY_ID = TRANSACTION_TYPES.reduce((acc, type) => {
    acc[type.id] = type;
    return acc;
}, {});

export function transactionTypeLabelKey(id) {
    return `app.transactionTypes.options.${id}`;
}

/**
 * Resolve the target project account for a business-event type given a project's
 * accounts.
 * @returns {{ resolved: object|null, candidates: object[], accountTypes: string[], direction: string|null }}
 */
export function resolveTargetProjectAccount(transactionTypeId, projectAccounts = []) {
    const spec = TRANSACTION_TYPES_BY_ID[transactionTypeId];
    if (!spec) {
        return { resolved: null, candidates: [], accountTypes: [], direction: null };
    }
    const candidates = projectAccounts.filter((pa) => spec.accountTypes.includes(pa.account_type));
    return {
        resolved: candidates.length === 1 ? candidates[0] : null,
        candidates,
        accountTypes: spec.accountTypes,
        direction: spec.direction,
    };
}
